import { ReactNode } from "react";

export interface ExtendedError {
    handled?: boolean;
    userMessage?: string | ReactNode;
}

export interface ErrorResponseData {
    message?: string;
    extendedError?: ExtendedError;
}

export interface ErrorResponse {
    status?: number;
    data?: ErrorResponseData;
}

export interface ApiError {
    response?: ErrorResponse;
}

export function isApiError(error: unknown): error is ApiError {
    return (
        typeof error === `object` &&
        error !== null &&
        `response` in error
    );
}
